import { getLayouts } from 'common/api/v1/layouts';

import {
    FETCH_PV_LAYOUT,
    FETCH_PV_LAYOUT_FAILURE,
    FETCH_PV_LAYOUT_SUCCESS,
} from '../actionTypes';
import { multiTemplateReviewActions } from '../reducer';

export default (layoutId) => (dispatch) =>
    new Promise((resolve) => {
        dispatch(multiTemplateReviewActions[FETCH_PV_LAYOUT]());

        getLayouts(layoutId)
            .then((response) => {
                const layout = response?.data?.data;
                const data = {
                    parent_field_segments: [
                        {
                            id: layout.id,
                            latitude: layout.latitude,
                            longitude: layout.longitude,
                            field_segments: layout.segments,
                        },
                    ],
                };
                dispatch(
                    multiTemplateReviewActions[FETCH_PV_LAYOUT_SUCCESS](data),
                );
            })
            .catch((error) => {
                dispatch(
                    multiTemplateReviewActions[FETCH_PV_LAYOUT_FAILURE](
                        error?.response?.data?.errors,
                    ),
                );
            })
            .finally(resolve);
    });
